function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireStreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "159.34mm",
    height: "314.37mm",
    viewBox: "0 0 159.34 314.37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1185",
    x1: -11.225,
    x2: 214.29,
    y1: 662.41,
    y2: 1140.3,
    gradientTransform: "matrix(.65854 0 0 .65854 48.497 -430.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f3ff33"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f32700"
    },
    offset: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.942 -6.1011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.105 6.1011s5.6454 4.2407 13.388 12.829c7.7931 8.6438 17.176 21.532 23.381 38.383 4.6366 12.884 7.3588 27.89 5.5886 41.777-0.37747-0.01201-0.58265-8e-3 -0.58265-8e-3s0.20491 0.0859 0.5505 0.24953c-0.39433 3.0014-0.9954 5.9498-1.838 8.8118-3.503 14.898-14.019 29.07-24.399 46.206-0.41991 0.63472-0.83988 1.2741-1.2592 1.9177-10.613 16.291-21.22 36.06-25.067 59.414-4.0102 28.552 5.4911 54.086 19.325 71.466 14.294 17.912 31.838 26.211 43.734 29.812 12.162 3.6812 19.438 3.375 19.438 3.375s-6.8127-2.7175-16.191-9.8485c-9.3687-7.1227-20.851-18.86-27.583-35.25-6.4678-15.679-8.1619-34.979-2.5981-51.949 2.7766-9.7663 8.4049-19.243 14.876-29.49 1.2805 6.7266 4.1714 12.583 7.5037 17.092 5.1923 7.1034 11.273 11.255 15.618 13.537 4.3912 2.3068 7.1603 2.9531 7.1603 2.9531s-2.2874-1.7324-5.4239-5.2387c-3.157-3.5291-6.9579-8.7911-9.4716-15.671-2.2956-6.4288-3.4346-14.151-1.5062-20.753 1.4191-6.0824 5.6793-11.869 9.8845-18.865 0.1701-0.25915 0.33946-0.52051 0.50934-0.78329 0.0259-0.0401 0.0513-0.0833 0.0772-0.12357 3.8659 15.354 10.688 28.608 17.778 39.272 0.32399 0.55282 0.64893 1.0994 0.97366 1.6412 8.2622 13.784 16.702 24.059 20.129 34.301 4.9037 11.916 4.9654 26.752 0.97366 39.462-4.1593 13.349-12.581 23.703-19.875 30.31-7.2653 6.5804-12.836 9.4048-12.836 9.4048s6.1262 0.82537 16.752-1.591c10.359-2.3558 26.063-8.5602 39.368-23.752 12.885-14.763 22.252-37.142 19.23-63.036-3.1354-21.079-12.011-38.637-20.912-52.108-0.35218-0.53295-0.70437-1.0599-1.0573-1.582-8.4448-14.21-17.145-24.704-20.179-35.225-4.4352-11.311-3.4405-26.136 0.0424-39.107 3.9069-13.917 10.656-25.089 16.572-32.869 5.8479-7.6913 10.315-11.713 10.315-11.713s-5.9012 0.8119-15.487 4.9584c-9.4667 4.0947-22.984 11.989-34.885 26.568-2.0168 2.4358-3.9733 5.0885-5.824 7.9359-1.6734-20.883-10.039-38.999-19.963-52.324-12.817-17.398-27.829-27.565-38.555-33.156-10.84-5.65-17.675-7.2311-17.675-7.2311z",
    style: {
      fill: "url(#linearGradient1185)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireStreak);
export default __webpack_public_path__ + "static/media/fire-streak.5d1c9652f6ea78c439feb17c338f6f16.svg";
export { ForwardRef as ReactComponent };